import { defineMessages, MessageDescriptor } from 'react-intl';

export const valuePropMessages: Record<string, MessageDescriptor> = defineMessages({
	vpLabel1: {
		id: 'secondFreeTrial.vpLabel1',
		defaultMessage: 'Stress less',
		description: 'Description of a reason to join calm premium.',
	},
	vpBody1: {
		id: 'secondFreeTrial.vpBody1',
		defaultMessage:
			'Learn how to steady your mind with hundreds of guided meditations for any experience level.',
		description: 'How joining calm premium will help you stress less.',
	},
	vpLabel2: {
		id: 'secondFreeTrial.vpLabel2',
		defaultMessage: 'Relax more',
		description: 'Description of a reason to join calm premium.',
	},
	vpBody2: {
		id: 'secondFreeTrial.vpBody2',
		defaultMessage: 'Improve your wellbeing with mindful stretches, breathing exercises, and more.',
		description: 'How joining calm premium will help you relax more.',
	},
	vpLabel3: {
		id: 'secondFreeTrial.vpLabel3',
		defaultMessage: 'Sleep better',
		description: 'Description of a reason to join calm premium.',
	},
	vpBody3: {
		id: 'secondFreeTrial.vpBody3',
		defaultMessage:
			'Drift into dreamland with celebrity-read Sleep Stories, music, and soothing soundscapes.',
		description: 'How joining calm premium will help you sleep better.',
	},
});

export const validationMessages: Record<string, MessageDescriptor> = defineMessages({
	validationHeadline: {
		id: 'secondFreeTrial.validationHeadline',
		defaultMessage: 'Join millions of happy users.',
		description: 'Headline for a section that shows the benefits of using Calm.',
	},
	validationStat1: {
		id: 'secondFreeTrial.stat1',
		defaultMessage: '<stat>90%</stat> Reported less anxiety*',
		description:
			'A statistic that shows a benefit of using the Calm app. The asterisk refers to secondFreeTrial.sourceDetail.',
	},
	validationStat2: {
		id: 'secondFreeTrial.stat2',
		defaultMessage: '<stat>85%</stat> Expressed higher quality sleep*',
		description:
			'A statistic that shows a benefit of using the Calm app. The asterisk refers to secondFreeTrial.sourceDetail.',
	},
	validationStat3: {
		id: 'secondFreeTrial.stat3',
		defaultMessage: '<stat>84%</stat> Reported improved mental health*',
		description:
			'A statistic that shows a benefit of using the Calm app. The asterisk refers to secondFreeTrial.sourceDetail.',
	},
	validationSourceDetail: {
		id: 'secondFreeTrial.sourceDetail',
		defaultMessage: '*Based on a study using survey data from subscribers who used the app 5+ times a week.',
		description: 'A note that provides additional context for the statistics provided about calm features.',
	},
	validationQuote1: {
		id: 'secondFreeTrial.quote1',
		defaultMessage:
			'"I was struggling with anxiety and restless nights as I am working full time and going to school full time and couldn’t seem to quiet my mind at bed time. The meditations, sleep stories, and ambient noise have all helped me tremendously."',
		description: 'A testimonial talking about the benefits of using Calm.',
	},
	validationQuote1Name: {
		id: 'secondFreeTrial.quote1Name',
		defaultMessage: 'Celeste',
		description: 'The name of the user who provided the testimonial in secondFreeTrial.quote1.',
	},
	validationQuote1Description: {
		id: 'secondFreeTrial.quote1Description',
		defaultMessage: 'Member since June 2017',
		description: 'A description of a user who provided a testimonial.',
	},
	validationQuote2: {
		id: 'secondFreeTrial.quote2',
		defaultMessage:
			'"The sleep tools in the Calm app have really helped me unwind before bed. Sometimes my son has a hard time falling asleep and the Magic Wand has been a favorite. I sometimes struggle not to fall asleep before he does!"',
		description: 'A testimonial talking about the benefits of using Calm.',
	},
	validationQuote2Name: {
		id: 'secondFreeTrial.quote2Name',
		defaultMessage: 'John',
		description: 'The name of the user who provided the testimonial in secondFreeTrial.quote2.',
	},
	validationQuote2Description: {
		id: 'secondFreeTrial.quote2Description',
		defaultMessage: 'Member since August 2018',
		description: 'A description of a user who provided a testimonial.',
	},
	validationQuote3: {
		id: 'secondFreeTrial.quote3',
		defaultMessage:
			'"Calm has changed my life in immeasurable ways. Emotionally, I\'m more resillient. I have a better relationship with myself, a stronger sense of who I am, and I hold a lot less tension in my body."',
		description: 'A testimonial talking about the benefits of using Calm.',
	},
	validationQuote3Name: {
		id: 'secondFreeTrial.quote3Name',
		defaultMessage: 'Allison',
		description: 'The name of the user who provided the testimonial in secondFreeTrial.quote3.',
	},
	validationQuote3Description: {
		id: 'secondFreeTrial.quote3Description',
		defaultMessage: 'Member since May 2017',
		description: 'A description of a user who provided a testimonial.',
	},
});

export const featuresMessages: Record<string, MessageDescriptor> = defineMessages({
	featuresHeadline: {
		id: 'secondFreeTrial.featuresHeadline',
		defaultMessage: 'Access our entire library of wellness content and tools.',
		description: 'A description of a benefit of becoming a Calm subscriber.',
	},
	feature1ButtonText: {
		id: 'secondFreeTrial.feature1ButtonText',
		defaultMessage: 'Daily Series',
		description: 'A label describing daily series like the Daily Calm.',
	},
	feature1Label: {
		id: 'secondFreeTrial.feature1Label',
		defaultMessage: 'Start your day with 7 minutes of wisdom',
		description: 'A benefit of becoming a Calm subscriber',
	},
	feature1Body: {
		id: 'secondFreeTrial.feature1Body',
		defaultMessage:
			'Original and inspiring meditations added everyday. Learn from experts such as Jay Shetty, Tamara Levitt, and Jeff Warren.',
		description: 'A description of a benefit of becoming a Calm subscriber.',
	},
	feature2ButtonText: {
		id: 'secondFreeTrial.feature2ButtonText',
		defaultMessage: 'Meditation',
		description: 'A label for meditation content.',
	},
	feature2Label: {
		id: 'secondFreeTrial.feature2Label',
		defaultMessage: 'Reach your goals with meditations for beginners',
		description: 'A benefit of becoming a Calm subscriber',
	},
	feature2Body: {
		id: 'secondFreeTrial.feature2Body',
		defaultMessage:
			'Intro courses to help you manage stress, reduce anxiety, boost self-esteem, increase happiness, and much more.',
		description: 'A description of a benefit of becoming a Calm subscriber.',
	},
	feature3ButtonText: {
		id: 'secondFreeTrial.feature3ButtonText',
		defaultMessage: 'Sleep',
		description: 'A label for sleep content.',
	},
	feature3Label: {
		id: 'secondFreeTrial.feature3Label',
		defaultMessage: 'Fall asleep to short stories, meditations, and music',
		description: 'A benefit of becoming a Calm subscriber',
	},
	feature3Body: {
		id: 'secondFreeTrial.feature3Body',
		defaultMessage:
			'Bedtime stories for both adults and kids that have helped millions of people across the globe improve sleep quality.',
		description: 'A description of a benefit of becoming a Calm subscriber.',
	},
	feature4ButtonText: {
		id: 'secondFreeTrial.feature4ButtonText',
		defaultMessage: 'Music & Soundscapes',
		description: 'A label for music and soundscape content.',
	},
	feature4Label: {
		id: 'secondFreeTrial.feature4Label',
		defaultMessage: 'Listen to tracks designed to help you focus, relax, or sleep',
		description: 'A benefit of becoming a Calm subscriber',
	},
	feature4Body: {
		id: 'secondFreeTrial.feature4Body',
		defaultMessage:
			'Nature sounds, ambient music, and more. Also find exclusive remixes from Ariana Grande, Sam Smith, and many more.',
		description: 'A description of a benefit of becoming a Calm subscriber.',
	},
	feature5ButtonText: {
		id: 'secondFreeTrial.feature5ButtonText',
		defaultMessage: 'Movement',
		description: 'A label for Movement content like the Daily Move.',
	},
	feature5Label: {
		id: 'secondFreeTrial.feature5Label',
		defaultMessage: 'Learn to move more mindfully',
		description: 'A benefit of becoming a Calm subscriber',
	},
	feature5Body: {
		id: 'secondFreeTrial.feature5Body',
		defaultMessage:
			'Short-form videos with stretches and exercises designed to make you feel immediate comfort, relief, and joy.',
		description: 'A description of a benefit of becoming a Calm subscriber.',
	},
	feature6ButtonText: {
		id: 'secondFreeTrial.feature6ButtonText',
		defaultMessage: 'Check-Ins',
		description: 'A label for a calm feature that lets you keep a log of how you feel each day.',
	},
	feature6Label: {
		id: 'secondFreeTrial.feature6Label',
		defaultMessage: 'Reflect on your mindfulness journey',
		description: 'A benefit of becoming a Calm subscriber',
	},
	feature6Body: {
		id: 'secondFreeTrial.feature6Body',
		defaultMessage:
			'Tools to encourage self-reflection such as gratitude, mood, and sleep check-ins. Track your progress over time.',
		description: 'A description of a benefit of becoming a Calm subscriber.',
	},
});

export const conversionMessages: Record<string, MessageDescriptor> = defineMessages({
	conversionHeadline: {
		id: 'secondFreeTrial.conversionHeadline',
		defaultMessage: 'Experience everything Calm has to offer with a free trial of Premium.',
		description: 'An invitation to take a free trial of calm.',
	},
	programName: {
		id: 'secondFreeTrial.programName',
		defaultMessage: '14 Day Free Trial',
		description: 'Describe the length of the free trial',
	},
	programDetail: {
		id: 'secondFreeTrial.programDetail2',
		defaultMessage:
			'After your trial ends, you’ll be billed annually at {yearlyPrice} ({monthlyPrice}/month). Cancel anytime.',
		description: 'Terms of the free trial.',
	},
});

export const heroMessages: Record<string, MessageDescriptor> = defineMessages({
	heroHeadline: {
		id: 'secondFreeTrial.heroHeadline',
		defaultMessage: 'Try Calm Premium again for free',
		description: 'An invitation to begin a second free trial of Calm Premium.',
	},
	heroDetail: {
		id: 'secondFreeTrial.heroDetail',
		defaultMessage:
			'Need extra time to continue your mindfulness journey? Get an extra 14 days to discover the wellness tools that work for you.',
		description: 'Information about beginning a second free trial of Calm Premium.',
	},
});

export const sharedMessages: Record<string, MessageDescriptor> = defineMessages({
	sharedSpecialLabel: {
		id: 'secondFreeTrial.sharedSpecialLabel',
		defaultMessage: 'Limited Time Offer',
		description: 'This offer is only valid for a short time',
	},
	sharedSpecialOfferFor: {
		id: 'secondFreeTrial.sharedSpecialOfferFor',
		defaultMessage: 'Special offer for {email}',
		description:
			'Text that highlights the fact that this is a special offer specifically created for the user with a particular email',
	},
	sharedCta: {
		id: 'secondFreeTrial.sharedCta',
		defaultMessage: 'Start your free trial',
		description: 'An invitation to take a free trial of calm.',
	},
	sharedPaymentHeader: {
		id: 'secondFreeTrial.sharedPaymentHeader',
		defaultMessage: 'Start your free 14 day trial today.',
		description: 'Invitation to complete payment in order to start your free trial.',
	},
	sharedLoginHeader: {
		id: 'secondFreeTrial.sharedLoginHeader',
		defaultMessage: 'Log into your account to redeem your offer.',
		description: 'Heading for log in page where users can redeem their second free trial',
	},
	sharedPaymentDetailsInfo: {
		id: 'secondFreeTrial.sharedPaymentDetailsInfo',
		defaultMessage:
			'*After your trial ends, you will be charged for Calm Premium at {value}, billed annually. Cancel anytime.',
		description: 'Extra information about how billing will work once you start a free trial.',
	},
});

export default {
	...valuePropMessages,
	...conversionMessages,
	...validationMessages,
	...featuresMessages,
	...heroMessages,
	...sharedMessages,
};
